import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../../shared/i18n';
import { TranslatedText } from '../../../shared/ui/TranslatedText';

const EmptyProfileState = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(6),
  textAlign: 'center',
}));

export function UserNotFound() {
  const { t } = useI18n();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <EmptyProfileState>
      <TranslatedText messageKey="profile.userNotFound" variant="h6" />
      <TranslatedText
        messageKey="profile.userNotFoundHint"
        variant="body2"
        color="text.secondary"
      />
      <Button variant="outlined" onClick={handleGoHome}>
        {t('notFound.primaryAction')}
      </Button>
    </EmptyProfileState>
  );
}
